"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.WAREHOUSE_AUDIENCE_KEY = exports.SdkLanguageType = exports.OFF_VARIATION_KEY = exports.DEFAULT_VISITOR_DATA_FILTERS = exports.CACHE_ITEM_LIFETIME = exports.CACHE_CLEANUP_TIMEOUT = void 0;
var OFF_VARIATION_KEY = exports.OFF_VARIATION_KEY = "off",
  WAREHOUSE_AUDIENCE_KEY = exports.WAREHOUSE_AUDIENCE_KEY = "warehouseAudiences",
  CACHE_CLEANUP_TIMEOUT = exports.CACHE_CLEANUP_TIMEOUT = 10,
  CACHE_ITEM_LIFETIME = exports.CACHE_ITEM_LIFETIME = 5;
var SdkLanguageType = exports.SdkLanguageType = function (a) {
  return a.ANDROID = "ANDROID", a.IOS = "IOS", a.JAVA = "JAVA", a.CSHARP = "CSHARP", a.NODEJS = "NODEJS", a.PHP = "PHP", a.RUBY = "RUBY", a.GO = "GO", a.FLUTTER = "FLUTTER", a.REACT = "REACT", a.PYTHON = "PYTHON", a.JAVASCRIPT = "JAVASCRIPT", a.RUST = "RUST", a;
}({});
var DEFAULT_VISITOR_DATA_FILTERS = exports.DEFAULT_VISITOR_DATA_FILTERS = {
  previousVisitAmount: 1,
  currentVisit: !0,
  customData: !0,
  pageViews: !1,
  geolocation: !1,
  device: !1,
  browser: !1,
  operatingSystem: !1,
  conversions: !1,
  experiments: !1,
  kcs: !1,
  visitorCode: !0
};